import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

// Legacy bootstrap — order matters: globals first (sets up window.React),
// then PA_DATA stub, then pages, then the App component that exposes window.__LegacyApp.
import "./globals.js";
import "./styles.css";
import "./data.js";
import "./tweaks-panel.jsx";
import "./components.jsx";
import "./page-landing.jsx";
import "./page-parcours-list.jsx";
import "./page-parcours-detail.jsx";
import "./page-explore.jsx";
import "./page-admin.jsx";
import "./page-organization.jsx";
import "./app.jsx";

import queryClient from "./lib/queryClient";
import { AuthProvider } from "./auth/AuthContext";
import AppRouter from "./AppRouter";

const container = document.getElementById("app");
if (!container) {
  throw new Error("Missing #app root element");
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
